import { AppProps } from 'next/app';
import Error from './_error';
import '../styles/global.css';
import { FactuaProvider } from 'context/FactuaContext';
import GlobalIframe from 'components/UI/GlobalIframe/GlobalIframe';

export default function MyApp({ Component, pageProps }: AppProps): JSX.Element {
  return (
    <FactuaProvider>
      {pageProps.error ? <Error {...pageProps.error} /> : <Component {...pageProps} />}
      <GlobalIframe />
    </FactuaProvider>
  );
}
